module.exports = __webpack_public_path__ + "static/media/13.14175bc8.jpeg";